import React from 'react';
import { Button, Modal } from 'antd';
import { DownloadOutlined } from "@ant-design/icons";

import './dialog.css';

export const PrintDialog = ({ visible, handleAction, handleCancel }) => {
    const CloseSvg = () => (
        <svg width="24" height="24" viewBox="0 0 24 24">
            <path id="prefix__a" d="M20.993 5.02L14.013 12l6.98 6.98c.556.556.556 1.457 0 2.013-.556.556-1.457.556-2.013 0L12 14.013l-6.98 6.98c-.556.556-1.457.556-2.013 0-.556-.556-.556-1.457 0-2.013L9.987 12l-6.98-6.98c-.556-.556-.556-1.457 0-2.013.556-.556 1.457-.556 2.013 0L12 9.987l6.98-6.98c.556-.556 1.457-.556 2.013 0 .556.556.556 1.457 0 2.013z"/>
        </svg>
    );

    return (
        <Modal
            wrapClassName='print-dialog'
            title="Զգուշացում"
            closeIcon={<CloseSvg />}
            visible={visible}
            footer={null}
            width={720}
            bodyStyle={{ textAlign: 'center' }}
            onCancel={() => handleCancel(false)}
            centered
        >
            <div style={{ color: '#707f90' }}>Նախքան հաստատելը խնդրում ենք տպել փաստաթղթերը</div>
            <div>
                <Button
                    size={"large"}
                    onClick={handleAction}
                    style={{ margin: '32px 0 24px' }}
                    className='btn-purple mr-1'
                >
                    <DownloadOutlined />
                    Տպել Փաստաթղթերը
                </Button>
            </div>
        </Modal>
    );
}